// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"284":"e6026833","455":"6e0045c8","644":"314b432e","899":"24b2b80c"}[chunkId] + ".chunk.js";
};